import React from 'react';
import {Message, Form, Divider} from "semantic-ui-react";

function TranslationFlashCardAdder(
    {
        id,
        handleSetTranslationFlashCardData,
        questionNumber,
        value
    }
) {
    return (

        value ?
            <div style={{marginTop: 10, marginRight: 5, marginLeft: 5}}>
                <div style={{border: ' 3px solid', textAlign: 'left', width: 800}}>
                    <Message attached header={`Flash Card ${questionNumber + 1}`}
                             style={{paddingLeft: 10, paddingRight: 10}}/>
                    <Form className='attached fluid segment' width={8}>
                        <label style={{color: '#002b70'}}>Samoan Phrase:</label>
                        <Form.Input
                            fluid
                            placeholder='Samoan Phrase'
                            type='text'
                            name='samoanPhrase'
                            id={id}
                            value={value.samoanPhrase}
                            onChange={handleSetTranslationFlashCardData}
                        />
                        <label style={{color: '#002b70'}}>English Translation:</label>
                        <Form.Input
                            fluid
                            placeholder='English Phrase'
                            type='text'
                            name='englishPhrase'
                            id={id}
                            value={value.englishPhrase}
                            onChange={handleSetTranslationFlashCardData}
                        />
                        {
                            value.samoanAudio ?
                                <>
                                    <Form.Input label='Sound (Optional)' type='text' value={value.samoanAudio} name='samoanAudio' id={id}
                                                onChange={handleSetTranslationFlashCardData}/>
                                                <b>If you would like to change the audio, insert new audio file here</b>
                                    <Form.Input label='Sound (Optional)' type='file' name='samoanAudio' id={id}
                                                onChange={handleSetTranslationFlashCardData}/>
                                </>
                                :
                                <Form.Input label='Sound (Optional)' type='file' value={value.samoanAudio} name='samoanAudio' id={id}
                                            onChange={handleSetTranslationFlashCardData}/>
                        }
                        {
                            value.picture ?
                                <>
                                    <Form.Input label='Picture (Optional)' type='text' value={value.picture} name='picture' id={id}
                                                onChange={handleSetTranslationFlashCardData}/>
                                    <b>If you would like to change the audio, insert new audio file here</b>
                                    <Form.Input label='Picture (Optional)' type='file' name='picture' id={id}
                                                onChange={handleSetTranslationFlashCardData}/>
                                </>
                                :
                                <Form.Input label='Picture (Optional)' type='file' value={value.picture} name='picture' id={id}
                                            onChange={handleSetTranslationFlashCardData}/>
                        }





                    </Form>
                </div>
            </div>
            :
            <div style={{marginTop: 10, marginRight: 5, marginLeft: 5}}>
                <div style={{border: ' 3px solid', textAlign: 'left', width: 800}}>
                    <Message attached header={`Flash Card ${questionNumber + 1}`}
                             style={{paddingLeft: 10, paddingRight: 10}}/>
                    <Form className='attached fluid segment' width={8}>
                        <label style={{color: '#002b70'}}>Samoan Phrase:</label>
                        <Form.Input
                            fluid
                            placeholder='Samoan Phrase'
                            type='text'
                            name='samoanPhrase'
                            id={id}
                            onChange={handleSetTranslationFlashCardData}
                        />
                        <label style={{color: '#002b70'}}>English Translation:</label>
                        <Form.Input
                            fluid
                            placeholder='English Phrase'
                            type='text'
                            name='englishPhrase'
                            id={id}
                            onChange={handleSetTranslationFlashCardData}
                        />
                        <Form.Group widths='equal'>
                            <Form.Input label='Sound (Optional)' type='file' name='samoanAudio' id={id}
                                        onChange={handleSetTranslationFlashCardData}/>
                            <Form.Input label='Picture (Optional)' type='file' name='picture' id={id}
                                        onChange={handleSetTranslationFlashCardData}/>

                        </Form.Group>


                    </Form>
                </div>
            </div>


    )
}

export default TranslationFlashCardAdder
